var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{tag:"component",attrs:{"value":_vm.value,"disabled":_vm.disabled,"is-mobile":_vm.isMobile},on:{"input":function($event){return _vm.$emit('input', $event)},"change":function($event){return _vm.$emit('change', $event)},"on:mode":function($event){_vm.mode = $event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }